import React, { useState } from 'react'
import Button from 'transfix-ui/components/Button'
import Spinner from 'transfix-ui/components/Spinner'
import { Table, TableBody, TableHead, TableCell, TableRow } from 'transfix-ui/components/Table'
import { EdiConfigGroupMappingTableRow } from './EdiConfigGroupMappingTableRow'
import { EdiConfigGroupMappingForm } from './forms/EdiConfigGroupMappingForm'
import { TEdiConfigGroupMappingSchema } from './forms/EdiConfigGroupMappingSchema'
import { useEdiMessageTypeMutations } from './hooks/useConfigGroupMappingMutations'
import { useConfigGroupMappings } from './hooks/useConfigGroupMappings'

interface IEdiConfigGroupTableProps {
  connectionConfigId: string
  shipperId: string
  shipperName: string | undefined
}

export function EdiConfigGroupTable({
  connectionConfigId,
  shipperId,
  shipperName,
}: IEdiConfigGroupTableProps) {
  const [showAddForm, setShowAddForm] = useState(false)

  const { data, loading: configGroupMappingsLoading } = useConfigGroupMappings({
    connectionConfigId,
  })

  const configGroupMappings = data?.configGroupMappings

  const showAddFormHandler = () => setShowAddForm(true)
  const cancelAddFormHandler = () => setShowAddForm(false)
  const { submitConfigGroupMapping } = useEdiMessageTypeMutations()

  const submitSuccessHandler = (formParams: TEdiConfigGroupMappingSchema) => {
    const configGroups = [...new Set(configGroupMappings?.map(mapping => mapping.configGroup))]
    submitConfigGroupMapping(formParams, connectionConfigId, shipperId, configGroups)
    setShowAddForm(false)
  }

  return (
    <>
      <div>
        {!showAddForm && <Button onClick={showAddFormHandler}>Add</Button>}
        {showAddForm && (
          <EdiConfigGroupMappingForm
            configGroupMapping={null}
            connectionConfigId={connectionConfigId}
            onCancel={cancelAddFormHandler}
            onSubmitSuccess={submitSuccessHandler}
            shipperName={shipperName}
          />
        )}
      </div>
      <Table>
        <TableHead>
          <TableRow tableCellType='th'>
            <TableCell>Name</TableCell>
            <TableCell>ISA Sender ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {configGroupMappingsLoading && (
            <TableRow>
              <TableCell colSpan={3}>
                <Spinner />
              </TableCell>
            </TableRow>
          )}
          {configGroupMappings?.map(configGroupMapping => {
            return (
              <EdiConfigGroupMappingTableRow
                key={configGroupMapping.id}
                configGroupMapping={configGroupMapping}
                onSubmit={submitSuccessHandler}
              />
            )
          })}
        </TableBody>
      </Table>
    </>
  )
}
